// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"650":"dcab35db","954":"3b0148e6"}[chunkId] + ".css";
};